<template>

    <div 
        class="p-2 max-w-xs flex items-center gap-2 w-[320px]"
        :class="{'bg-gray-300': !message.mine, 'rounded-r-lg': !message.mine, 'rounded-bl-lg': !message.mine, 'bg-blue-600': message.mine, 'rounded-l-lg': message.mine, 'rounded-br-lg': message.mine, 'text-white': message.mine}">
            <button type="button" @click="handlePlayAudio">
                <font-awesome-icon icon="fa-play" class="text-xl pointer-events-none" v-show="!isPlaying"></font-awesome-icon>
                <font-awesome-icon icon="fa-pause" class="text-xl pointer-events-none" v-show="isPlaying"></font-awesome-icon>
            </button>

            <div class="w-[300px] h-[10px] bg-gray-300" @click="handleClickTimeline">
                <div class="w-[10px] h-[10px] bg-blue-700 pointer-events-none" ref="progressBar"></div>
            </div>
    </div>  

</template>

<script setup>

import { onMounted, shallowRef, onUnmounted } from 'vue'
import { getDownloadURL, getStorage, ref } from 'firebase/storage'

import fire from "./fire"

const props = defineProps( {
    message: {
        type: Object,
        required: true
    }
} )


const isPlaying = shallowRef( false )
const progressBar = shallowRef( null )

let audio = null
let interval = null

onMounted( () => {
    const storage = getStorage( fire.app() )
    const audioRef = ref( storage, `audio/${ props.message.src }` )

    getDownloadURL( audioRef ).then( url => {
        audio = new Audio( url ) 

        audio.onended = () => {
            isPlaying.value = false
            audio.currentTime = 0
        }
    
        interval = setInterval( () => progressBar.value.style.width = audio.currentTime / audio.duration * 100 + '%', 500 )
    })
} )

onUnmounted( () => clearInterval( interval ) )


function handleClickTimeline( event ) {
    const timelineWidth = window.getComputedStyle( event.target ).width
    audio.currentTime = event.offsetX / parseInt( timelineWidth ) * audio.duration
}

function handlePlayAudio() {
    if ( !isPlaying.value ) {
        audio.play()
        isPlaying.value = true
    }

    else {
        audio.pause()
        isPlaying.value = false
    }
}

</script>
